import { Placeholder } from '@/shared/components/layout/Placeholder';

export function PagosPage() {
  return (
    <Placeholder
      title="Pagos"
      subtitle="Registro de cobros de ventas"
      description="Próximamente."
    />
  );
}
